import { useCallback } from "react";
import { useGoogleAnalyticsContext } from "contexts";
import { IShopPurchaseOfferMultiItem } from "contexts/WebStoreProvider/types";
import { RebateTracker } from "interfaces/rebate-offer";

interface Props {
	offer?: IShopPurchaseOfferMultiItem;
	rebateTracker?: RebateTracker;
	nowTime?: moment.Moment | null;
	rewardType?: { id?: string };
	currentProgress?: number;
	source?: string;
	eventType?: string;
}

const useRebateAnalytics = ({
	offer,
	rebateTracker,
	nowTime,
	rewardType,
	currentProgress,
	source,
	eventType
}: Props) => {
	const { reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const sendAnalytics = useCallback(
		(action: string) => {
			if (!nowTime) {
				return;
			}

			if (rebateTracker) {
				const endTime = new Date(rebateTracker?.expirationDate ?? 0).getTime();
				const timeLeft = Math.max(
					0,
					Math.floor((endTime - nowTime.valueOf()) / 1000)
				);
				const timeTotal = Math.floor(
					(rebateTracker?.durationMinutes ?? 0) * 60
				);

				reportPlaygamiEvent("tp.web_frontend", {
					event_name: eventType,
					event_type: "web_rebate_offer",
					action,
					source,
					offer_id: rebateTracker?.webOfferId,
					type: rewardType?.id,
					time_left: timeLeft,
					time_total: timeTotal,
					event_id: rebateTracker?.configId,
					value_int: currentProgress,
					value_int2: rebateTracker?.targetSpend,
					status: "purchased",
					loopcount: rebateTracker?.earnedCount
				});
				return;
			}
			if (offer) {
				const endTime = new Date(offer?.endTime).getTime();
				const startTime = new Date(offer?.startTime).getTime();
				const timeLeft = Math.max(
					0,
					Math.floor((endTime - nowTime.valueOf()) / 1000)
				);
				const timeTotal = Math.floor((endTime - startTime) / 1000);

				reportPlaygamiEvent("tp.web_frontend", {
					event_name: eventType,
					event_type: "web_rebate_offer",
					action,
					source,
					offer_id: offer?.id,
					type: rewardType?.id,
					time_left: timeLeft,
					time_total: timeTotal,
					status: "not_purchased"
				});
			}
		},
		[
			offer,
			rebateTracker,
			nowTime,
			rewardType,
			currentProgress,
			source,
			eventType,
			reportPlaygamiEvent
		]
	);

	return {
		sendAnalytics
	};
};
export { useRebateAnalytics };
